import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    id: "faq-item-1",
    q: "¿Mis clientes sabrán que es una app automática?",
    a: "No. Los mensajes salen con el nombre de tu negocio y el tono que tú defines. Puedes revisar y editar cada plantilla. La mayoría de clientes cree que les escribes personalmente.",
  },
  {
    id: "faq-item-2",
    q: "¿Tiene costo por transacción o comisión por cobro?",
    a: "Cero comisiones. Pagas solo tu plan mensual. El dinero va directo de tu cliente a tu cuenta bancaria o billetera digital; YateAviso nunca toca tu dinero.",
  },
  {
    id: "faq-item-3",
    q: "¿Funciona en cualquier país de Latinoamérica?",
    a: "Sí. Funcionamos en toda la región con soporte para Yape y Plin (Perú), Mercado Pago (México, Argentina, Colombia, Chile y más) y Stripe para pagos internacionales.",
  },
  {
    id: "faq-item-4",
    q: "¿Cómo se conecta con mi sistema actual?",
    a: "No necesitas cambiar nada. Sube tus facturas por CSV, foto o formulario. Si usas un sistema contable, el plan Pro Empresa incluye integraciones API para sincronizar automáticamente.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-3xl px-4 py-24 sm:px-6 lg:py-32">
    <Reveal className="text-center">
      <p className="mono mb-4 text-xs uppercase tracking-[0.2em] text-emerald-400">Preguntas frecuentes</p>
      <h2 className="font-display text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
        Lo que toda Mype pregunta antes de empezar.
      </h2>
    </Reveal>

    <Reveal delay={0.15} className="mt-12">
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f) => (
          <AccordionItem
            key={f.id}
            value={f.id}
            data-testid={f.id}
            className="rounded-2xl border border-white/10 bg-[#131316]/70 px-6 transition-colors duration-300 data-[state=open]:border-emerald-500/30"
          >
            <AccordionTrigger className="py-5 text-left font-display text-base font-semibold tracking-tight hover:no-underline hover:text-emerald-300 [&[data-state=open]]:text-emerald-400">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-400">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
